export default "__VITE_ASSET__DIq5aNsg__"